import React from 'react';
import { Redirect } from 'react-router-dom';

// Authentication related pages
import Login from '../pages/Authentication/Login';

// Dashboard
import Dashboard from '../pages/Dashboard/index';

// Pages Calendar
import Calendar from '../pages/Calendar/Calendar';

// Pages Component
import Chat from '../pages/Chat/Chat';

//Ecommerce Pages

import ProductDetail from '../pages/Ecommerce/ProductDetail';

import Customers from '../pages/Ecommerce/Customers';
import Cart from '../pages/Ecommerce/Cart';
import CheckOut from '../pages/Ecommerce/CheckOut';
import Shops from '../pages/Ecommerce/Shops';

//Email
import EmailInbox from '../pages/Email/email-inbox';
import EmailRead from '../pages/Email/email-read';

// Charts
import ChartApex from '../pages/Charts/Apexcharts';
import ChartjsChart from '../pages/Charts/ChartjsChart';
import SparklineChart from '../pages/Charts/SparklineChart';
import ChartsKnob from '../pages/Charts/charts-knob';

// Maps
import MapsGoogle from '../pages/Maps/MapsGoogle';
import MapsVector from '../pages/Maps/MapsVector';

//Icons
import RemixIcons from '../pages/Icons/RemixIcons';
import MaterialDesign from '../pages/Icons/MaterialDesign';
import DripiIcons from '../pages/Icons/DripiIcons';
import FontAwesome from '../pages/Icons/FontAwesome';

//Utility
import StarterPage from '../pages/Utility/StarterPage';
import Maintenance from '../pages/Utility/Maintenance';
import CommingSoon from '../pages/Utility/CommingSoon';
import Timeline from '../pages/Utility/Timeline';
import FAQs from '../pages/Utility/FAQs';
import Pricing from '../pages/Utility/Pricing';
import Error404 from '../pages/Utility/Error404';
import Error500 from '../pages/Utility/Error500';

// Forms
import FormElements from '../pages/Forms/FormElements';
import FormAdvanced from '../pages/Forms/FormAdvanced';
import FormEditors from '../pages/Forms/FormEditors';
import FormValidations from '../pages/Forms/FormValidations';
import FormMask from '../pages/Forms/FormMask';
import FormUpload from '../pages/Forms/FormUpload';
import FormWizard from '../pages/Forms/FormWizard';
import FormXeditable from '../pages/Forms/FormXeditable';

//Ui
import UiAlert from '../pages/Ui/UiAlert';
import UiButtons from '../pages/Ui/UiButtons';
import UiCards from '../pages/Ui/UiCards';
import UiCarousel from '../pages/Ui/UiCarousel';
import UiDropdown from '../pages/Ui/UiDropdown';
import UiGeneral from '../pages/Ui/UiGeneral';
import UiGrid from '../pages/Ui/UiGrid';
import UiImages from '../pages/Ui/UiImages';
import UiLightbox from '../pages/Ui/UiLightbox';
import UiModal from '../pages/Ui/UiModal';
import UiProgressbar from '../pages/Ui/UiProgressbar';
import UiSweetAlert from '../pages/Ui/UiSweetAlert';
import UiTabsAccordions from '../pages/Ui/UiTabsAccordions';
import UiTypography from '../pages/Ui/UiTypography';
import UiVideo from '../pages/Ui/UiVideo';
import UiSessionTimeout from '../pages/Ui/UiSessionTimeout';
import UiRating from '../pages/Ui/UiRating';
import UiRangeSlider from '../pages/Ui/UiRangeSlider';
import UiNotifications from '../pages/Ui/ui-notifications';
import UIRoundSlider from '../pages/Ui/UIRoundSlider';

//Tables
import BasicTables from '../pages/Tables/BasicTables';
import DatatableTables from '../pages/Tables/DatatableTables';
import ResponsiveTables from '../pages/Tables/ResponsiveTables';
import EditableTables from '../pages/Tables/EditableTables';

//Kanban Board
import KanbanBoard from '../pages/KanbanBoard/index';
import CreateAnnouncement from '../pages/Baythak/CreateAnnouncement/CreateAccouncement.jsx';
import Baythak from '../pages/Baythak/CreateAnnouncement/Baythak.jsx';

//Users Pages
import Ccr from '../pages/Ccr/ccr.jsx';
import Advisors from '../pages/Advisors/advisors.jsx';
import AdvisorNew from '../pages/Advisors/advisor-new';
import AdvisorDetails from '../pages/Advisors/advisor-details';
import Farmers from '../pages/Farmers/farmers';
import FarmerDetail from '../pages/Farmers/farmer-details';
import Buyers from '../pages/Buyer/buyer';
import BuyerDetail from '../pages/Buyer/buyer-details';
import { Languages } from '../pages/Languages/languages';
import { Raqbas } from '../pages/Raqbas/rabas';

import { Districts } from '../pages/Districts/districts';
import { Cities } from '../pages/Cities/cities';
import { Vegetables } from '../pages/Vegetables/vegetables';
import AddVegetable from '../pages/Vegetables/add-vegetable';
import VegetableDetails from '../pages/Vegetables/vegetable-details';

import Categories from '../pages/Categories/categories';

import AddProduct from '../pages/Products/add-product';
import ProductDetails from '../pages/Products/product-details';
import { Products } from '../pages/Products/products';
import { Orders } from '../pages/Orders/orders';
import CategoryDetails from '../pages/Categories/category-details';
import CategoryNew from '../pages/Categories/category-new';

import CompanyNew from '../pages/Companies/company-new';
import CompanyDetails from '../pages/Companies/company-details';
import Companies from '../pages/Companies/companies';
import AdvisoryExpertises from '../pages/AdvisoryExpertise/advisory-expertises';
import AdvisoryExpertiseDetails from '../pages/AdvisoryExpertise/advisory-expertise-details';
import AddAdvisoryExpertise from '../pages/AdvisoryExpertise/add-advisory-expertise';
import AdvisoryStats from '../pages/AdvisoryStats/advisory-stats';
import AddAdvisoryStat from '../pages/AdvisoryStats/add-advisory-stat';
import AdvisoryStatDetails from '../pages/AdvisoryStats/advisory-stats-details';
import Mundi from '../pages/Mundi/mundi';
import MundiBids from '../pages/Mundi/mundi-bids';
import AdvisorySessions from '../pages/AdvisorySessions/advisorySessions';
import AdvisorySessionChats from '../pages/AdvisorySessions/advisorySessionChats';
import PostDetails from '../pages/Baythak/CreateAnnouncement/components/post-details';
import DistrictDetails from '../pages/Districts/district-details';
import CitiesDetails from '../pages/Cities/cities-details';
import CcrDetails from '../pages/Ccr/ccr-details';
import CcrNew from '../pages/Ccr/ccr-new';
import Loan from '../pages/Loan/Loan';
import LoanDetail from '../pages/Loan/Loan-detail';
import LoanAnalytics from '../pages/Loan/Loan-analyticss.jsx';
import LoanList from '../pages/Loan/Loan-list.jsx';

// By Atqie...............
import LoanList2 from '../pages/Loan/Loan-list2.jsx';
import LoanDetail2 from '../pages/Loan/LoanDetail2.jsx';
// coded by atiq
import LoanFinancials from '../pages/Loan/Loan-financialss.jsx';
import AgroData from '../pages/Loan/AgroData.jsx';
import ResetPassword from '../pages/Loan/ResetPassword.jsx';
import UserDeleted from '../pages/Loan/UserDeleted.jsx';

const authProtectedRoutes = [
  {
    path: '/baythak/create-announcement',
    component: CreateAnnouncement,
  },
  {
    path: '/post-details/:id',
    component: PostDetails,
  },

  {
    path: '/baythak',
    component: Baythak,
  },
  {
    path: '/users/advisors',
    component: Advisors,
  },
  {
    path: '/users/ccr',
    component: Ccr,
  },
  {
    path: '/users/farmers',
    component: Farmers,
  },
  {
    path: '/users/add-new-advisor',
    component: AdvisorNew,
  },
  {
    path: '/users/add-new-ccr',
    component: CcrNew,
  },
  {
    path: '/users/edit-advisor/:id',
    component: AdvisorDetails,
  },
  {
    path: '/users/edit-ccr/:id',
    component: CcrDetails,
  },
  {
    path: '/users/edit-farmer/:id',
    component: FarmerDetail,
  },
  {
    path: '/users/buyers',
    component: Buyers,
  },
  {
    path: '/users/edit-buyer/:id',
    component: BuyerDetail,
  },
  {
    path: '/system/languages',
    component: Languages,
  },
  {
    path: '/system/raqbas',
    component: Raqbas,
  },
  {
    path: '/system/advisors-expertise',
    component: AdvisoryExpertises,
  },
  {
    path: '/system/advisors-expertise-details/:id',
    component: AdvisoryExpertiseDetails,
  },
  {
    path: '/system/add-new-advisory-expertise',
    component: AddAdvisoryExpertise,
  },

  {
    path: '/system/advisory-stats',
    component: AdvisoryStats,
  },
  {
    path: '/system/add-new-advisory-stat',
    component: AddAdvisoryStat,
  },
  {
    path: '/system/advisors-stat-details/:id',
    component: AdvisoryStatDetails,
  },
  {
    path: '/system/districts',
    component: Districts,
  },
  {
    path: '/district-details/:id',
    component: DistrictDetails,
  },
  {
    path: '/system/cities',
    component: Cities,
  },
  {
    path: '/cities-details/:id',
    component: CitiesDetails,
  },
  {
    path: '/system/vegetables',
    component: Vegetables,
  },
  {
    path: '/system/add-vegetable',
    component: AddVegetable,
  },
  {
    path: '/system/vegetable-details/:id',
    component: VegetableDetails,
  },
  {
    path: '/mundi',
    component: Mundi,
  },
  {
    path: '/supplies/categories',
    component: Categories,
  },
  {
    path: '/supplies/add-new-category',
    component: CategoryNew,
  },
  {
    path: '/supplies/category-details/:id',
    component: CategoryDetails,
  },

  {
    path: '/supplies/companies',
    component: Companies,
  },
  {
    path: '/supplies/add-new-company',
    component: CompanyNew,
  },
  {
    path: '/supplies/company-details/:id',
    component: CompanyDetails,
  },
  {
    path: '/supplies/products',
    component: Products,
  },
  {
    path: '/supplies/add-product',
    component: AddProduct,
  },
  {
    path: '/supplies/product-details/:id',
    component: ProductDetails,
  },
  {
    path: '/supplies/orders',
    component: Orders,
  },
  {
    path: '/mundi-bids/:id',
    component: MundiBids,
  },
  {
    path: '/advisory/sessions',
    component: AdvisorySessions,
  },
  {
    path: '/advisory-session/chats/:id',
    component: AdvisorySessionChats,
  },
  {
    path: '/loan',
    component: Loan,
  },
  {
    path: '/loan-list-bank',
    component: LoanList2,
  },

  // ................By atique................

  {
    path: '/reset-password',
    component: ResetPassword,
  },

  // {
  //     path: '/loan-list-2/:status',
  //     component: LoanList2
  // },

  // {
  //     path: '/loan-detail-2/:id/:loanId',
  //     component: LoanDetail2,
  // },

  // ..............End Here..............
  {
    path: '/loan-list/:status',
    component: LoanList2,
  },

  {
    path: '/loan-detail/:id/:loanId',
    component: LoanDetail2,
  },
  {
    path: '/master-data/:cnic',
    component: AgroData,
  },

  // {
  //     path: '/loan-detail/:id/:loanId',
  //     component: LoanDetail2,
  // },
  {
    path: '/loan-analytics/:loanId/:id',
    component: LoanAnalytics,
  },
  {
    path: '/loan-financials/:loanId/:id',
    component: LoanFinancials,
  },

  //Kanban Board
  {
    path: '/apps-kanban-board',
    component: KanbanBoard,
  },

  // Tables
  {
    path: '/tables-basic',
    component: BasicTables,
  },
  {
    path: '/tables-datatable',
    component: DatatableTables,
  },
  {
    path: '/tables-responsive',
    component: ResponsiveTables,
  },
  {
    path: '/tables-editable',
    component: EditableTables,
  },

  // Ui
  {
    path: '/ui-alerts',
    component: UiAlert,
  },
  {
    path: '/ui-buttons',
    component: UiButtons,
  },
  {
    path: '/ui-cards',
    component: UiCards,
  },
  {
    path: '/ui-carousel',
    component: UiCarousel,
  },
  {
    path: '/ui-dropdowns',
    component: UiDropdown,
  },
  {
    path: '/ui-general',
    component: UiGeneral,
  },
  {
    path: '/ui-grid',
    component: UiGrid,
  },
  {
    path: '/ui-images',
    component: UiImages,
  },
  {
    path: '/ui-lightbox',
    component: UiLightbox,
  },
  {
    path: '/ui-modals',
    component: UiModal,
  },
  {
    path: '/ui-progressbars',
    component: UiProgressbar,
  },
  {
    path: '/ui-sweet-alert',
    component: UiSweetAlert,
  },
  {
    path: '/ui-tabs-accordions',
    component: UiTabsAccordions,
  },
  {
    path: '/ui-typography',
    component: UiTypography,
  },
  {
    path: '/ui-video',
    component: UiVideo,
  },
  {
    path: '/ui-session-timeout',
    component: UiSessionTimeout,
  },
  {
    path: '/ui-rating',
    component: UiRating,
  },
  {
    path: '/ui-rangeslider',
    component: UiRangeSlider,
  },
  {
    path: '/ui-notifications',
    component: UiNotifications,
  },
  {
    path: '/ui-roundslider',
    component: UIRoundSlider,
  },

  // Forms
  {
    path: '/form-elements',
    component: FormElements,
  },
  {
    path: '/form-advanced',
    component: FormAdvanced,
  },
  {
    path: '/form-editors',
    component: FormEditors,
  },
  {
    path: '/form-mask',
    component: FormMask,
  },
  {
    path: '/form-uploads',
    component: FormUpload,
  },
  {
    path: '/form-wizard',
    component: FormWizard,
  },
  {
    path: '/form-validation',
    component: FormValidations,
  },
  {
    path: '/form-xeditable',
    component: FormXeditable,
  },

  //Utility
  {
    path: '/pages-starter',
    component: StarterPage,
  },
  {
    path: '/pages-timeline',
    component: Timeline,
  },
  {
    path: '/pages-faqs',
    component: FAQs,
  },
  {
    path: '/pages-pricing',
    component: Pricing,
  },

  //Icons
  {
    path: '/icons-remix',
    component: RemixIcons,
  },
  {
    path: '/icons-materialdesign',
    component: MaterialDesign,
  },
  {
    path: '/icons-dripicons',
    component: DripiIcons,
  },
  {
    path: '/icons-fontawesome',
    component: FontAwesome,
  },

  // Maps
  {
    path: '/maps-google',
    component: MapsGoogle,
  },
  {
    path: '/maps-vector',
    component: MapsVector,
  },

  //Charts
  {
    path: '/charts-apex',
    component: ChartApex,
  },
  {
    path: '/charts-chartjs',
    component: ChartjsChart,
  },
  {
    path: '/charts-sparkline',
    component: SparklineChart,
  },
  {
    path: '/charts-knob',
    component: ChartsKnob,
  },

  //Email
  {
    path: '/email-inbox',
    component: EmailInbox,
  },
  {
    path: '/email-read',
    component: EmailRead,
  },

  //Ecommerce
  {
    path: '/ecommerce-products',
    component: Products,
  },
  {
    path: '/ecommerce-product-detail',
    component: ProductDetail,
  },
  {
    path: '/ecommerce-orders',
    component: Orders,
  },
  {
    path: '/ecommerce-customers',
    component: Customers,
  },
  {
    path: '/ecommerce-cart',
    component: Cart,
  },
  {
    path: '/ecommerce-checkout',
    component: CheckOut,
  },
  {
    path: '/ecommerce-shops',
    component: Shops,
  },
  {
    path: '/ecommerce-add-product',
    component: AddProduct,
  },

  //chat
  {
    path: '/apps-chat',
    component: Chat,
  },

  //calendar
  {
    path: '/calendar',
    component: Calendar,
  },

  {
    path: '/dashboard',
    component: Dashboard,
  },

  // this route should be at the end of all other routes
  {
    path: '/',
    exact: true,
    component: () =>
      JSON.parse(localStorage.getItem('bankAdmin')) ? (
        <Redirect to="/loan-list-bank" />
      ) : (
        <Redirect to="/loan" />
      ),
  },
];

const publicRoutes = [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/pages-404',
    component: Error404,
  },
  {
    path: '/pages-500',
    component: Error500,
  },
  {
    path: '/user-delete',
    component: UserDeleted,
  },
];

export { authProtectedRoutes, publicRoutes };
